import axios from 'axios';

// Resize to a square 256px JPEG, upload to the current user's account, return the stored avatar_url.
export async function uploadAvatarFile(file) {
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const size = 256;
        const c = document.createElement('canvas');
        c.width = size; c.height = size;
        const ctx = c.getContext('2d');
        const min = Math.min(img.width, img.height);
        ctx.drawImage(img, (img.width - min) / 2, (img.height - min) / 2, min, min, 0, 0, size, size);
        resolve(c.toDataURL('image/jpeg', 0.85));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
  const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/avatar`, { image: dataUrl });
  return data.avatar_url;
}
